export default "__VITE_ASSET__82d9ed38__"